import React from "react";

const LiquidGlassModal = ({
  isOpen,
  success,
  onClose,
  successMessage,
  errorMessage,
}) => {
  if (!isOpen) return null;

  const handleExploreServices = () => {
    onClose();
    // Scroll to features section
    const featuresSection = document.querySelector(".features-section");
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleViewPortfolio = () => {
    onClose();
    // Scroll to testimonials or portfolio section
    const testimonialsSection = document.querySelector(".testimonials-section");
    if (testimonialsSection) {
      testimonialsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(25px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        className="glass liquid-float"
        style={{
          background: "var(--glass-bg-ultra-light)",
          backdropFilter: "blur(40px)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
          borderRadius: "32px",
          padding: "48px",
          maxWidth: "550px",
          width: "100%",
          textAlign: "center",
          boxShadow:
            "0 30px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)",
          animation: "modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
          position: "relative",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Animated Background Gradient */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: success
              ? "radial-gradient(circle at 30% 20%, rgba(52, 199, 89, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(48, 209, 88, 0.1) 0%, transparent 50%)"
              : "radial-gradient(circle at 30% 20%, rgba(255, 59, 48, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 105, 97, 0.1) 0%, transparent 50%)",
            borderRadius: "32px",
            animation: "pulseGlow 3s ease-in-out infinite alternate",
          }}
        />

        {/* Content */}
        <div style={{ position: "relative", zIndex: 1 }}>
          {/* Icon with Enhanced Animation */}
          <div
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              background: success
                ? "linear-gradient(135deg, #34c759 0%, #30d158 50%, #32d74b 100%)"
                : "linear-gradient(135deg, #ff3b30 0%, #ff6961 50%, #ff453a 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "3rem",
              margin: "0 auto 32px auto",
              boxShadow: success
                ? "0 15px 40px rgba(52, 199, 89, 0.4), 0 0 0 4px rgba(52, 199, 89, 0.1)"
                : "0 15px 40px rgba(255, 59, 48, 0.4), 0 0 0 4px rgba(255, 59, 48, 0.1)",
              animation: success
                ? "successBounce 0.6s ease-out"
                : "errorShake 0.5s ease-out",
              color: "white",
              fontWeight: "bold",
            }}
          >
            {success ? "✓" : "✕"}
          </div>

          {/* Title */}
          <h3
            className="heading-liquid"
            style={{
              fontSize: "1.75rem",
              marginBottom: "16px",
              color: "var(--text-glass-primary)",
              fontWeight: "700",
            }}
          >
            {success
              ? "🎉 Message Sent Successfully!"
              : "❌ Oops! Something went wrong"}
          </h3>

          {/* Message */}
          <p
            className="text-liquid"
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.7",
              marginBottom: success ? "40px" : "32px",
              color: "var(--text-glass-secondary)",
              opacity: 0.8,
            }}
          >
            {success ? successMessage : errorMessage}
          </p>

          {/* Action Buttons */}
          {success ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "12px",
                  marginBottom: "16px",
                }}
              >
                <button
                  className="glass-button glass-button-secondary glow"
                  style={{
                    padding: "14px 20px",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                  onClick={handleExploreServices}
                >
                  <span>🚀</span>
                  Explore Services
                </button>
                <button
                  className="glass-button glass-button-secondary glow"
                  style={{
                    padding: "14px 20px",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                  onClick={handleViewPortfolio}
                >
                  <span>💼</span>
                  View Portfolio
                </button>
              </div>
              <button
                className="glass-button glass-button-primary glow"
                style={{
                  padding: "16px 32px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  borderRadius: "20px",
                }}
                onClick={onClose}
              >
                Awesome! 🎯
              </button>
            </div>
          ) : (
            <button
              className="glass-button glass-button-primary glow"
              style={{
                padding: "16px 32px",
                fontSize: "1.1rem",
                fontWeight: "600",
                borderRadius: "20px",
              }}
              onClick={onClose}
            >
              Try Again 🔄
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiquidGlassModal;
